import { render, staticRenderFns } from "./punchingMenuTable.vue?vue&type=template&id=c38629a6&"
import script from "./punchingMenuTable.vue?vue&type=script&lang=js&"
export * from "./punchingMenuTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports